<template>
  <li 
    class="homework__item"
    :class="{ 
      new: formData.is_new,
      ending: isEndingsHomework && !formData.is_new
    }"
    v-if="formData"
  >
    <div class="homework-item__header" v-if="!is_template">
      <div class="homework-item__date">
        <div class="homework__date" @click.self="editDate = false" v-if="!formData.is_dynamical">
          <span class="ico-calendar" uk-tooltip="Дата"></span> 
          <span v-show="!editDate" @click="editDate = formData.is_new ? true : false">{{ formData.dates.join(', ') }}</span>

          <date-picker
            v-model="formData.dates"
            :value-type="'DD.MM.YYYY'"
            v-show="editDate"
            @input="editDate = false, is_saved = false"
            @blur="editDate = false"
            :clearable="false"
            :multiple="true"
            :disabled-date="date => date < disabledDate"
          ></date-picker>
        </div>

        <div class="homework__date" v-else>
          <span><i class="fas fa-cogs"></i> Динамическое задание</span>
        </div>

        <p class="warning-message" v-show="isEndingsHomework && !formData.is_new">Внимание! Задание заканчивается!</p>

        <div class="header-menu">
          <button 
            type="button" 
            class="header-menu__btn" 
            @click="openPopup('AddTrainer', null)"
            :class="{hide: !formData.is_new && formData.is_dynamical && !formData.template_id}"
          >
            <i class="fas fa-plus"></i>
            Тренажер
          </button>

          <button 
            type="button" 
            class="header-menu__btn header-menu__btn--remove" 
            @click="$emit('remove-lesson-block', {id: formData.id, is_new: formData.is_new, index})"
          >
            <i class="fas fa-trash-alt"></i>
            Удалить
          </button>
        </div> 
      </div>
    </div>

    <div class="template-menu" v-if="is_template">
      <span class="template-name">{{ formData.title }}</span>
      <button @click="removeTemplate" class="close close--remove-template" uk-tooltip="удалить"></button>
    </div>
    
    <draggable 
      v-model="formData.trainers" 
      class="trainer-list"
      @start="drag=true" 
      @end="drag=false"
      @update="is_saved = false"
      v-if="formData.trainers.length"
    >
      <li class="hwtrainer__item" v-for="(trainerItem, index) in formData.trainers" :key="trainerItem.id">
        <div class="homework__content">
          <div class="homework__title">            
            <div class="trainer-info">
              <span>
                {{ trainerItem.trainer ? trainerItem.trainer.title : trainerItem.params.title }}
              </span> 
              <span v-if="trainerItem.date && formData.is_dynamical">({{ trainerItem.date }})</span>  
              <span 
                class="uk-badge" 
                uk-tooltip="Количество повторов" 
                v-if="trainerItem.trainer"
              >
                {{ trainerItem.qnt }}
              </span>                         
            </div>

            <div v-if="!is_template">
              <span 
                class="uk-badge" 
                uk-tooltip="Добавить авто-настройки" 
                v-if="item.is_dynamical"
                @click="openPopup('AddAutoSettings', { trainerItem, index})"
              >
                <i class="fas fa-plus"></i> Auto
              </span> 
              
              <span 
                class="uk-badge uk-badge--edit" 
                uk-tooltip="Редактировать настройки домашнего задания" 
                uk-icon="pencil" 
                @click="openPopup('AddTrainer', trainerItem)"
              ></span>

              <span 
                class="uk-badge" 
                uk-tooltip="Скопировать задание" 
                uk-icon="copy"
                @click="copyTrainer(trainerItem, index)"
              ></span>

              <span 
                v-show="formData.trainers.length > 1"
                class="uk-badge uk-badge--delete" 
                uk-tooltip="Удалить задание" 
                uk-icon="close"
                @click="removeTrainer(index)"
              ></span>
            </div>
          </div>
          <div class="trainer-params-info">
            <div>
              <span class="trainer-params-text">Базовые</span>
              <TrainerInfo 
                :trainer="trainerItem.trainer" 
                :params="trainerItem.params"
                class="trainer-params-item"
              />
            </div>
            
            <div 
              v-for="(settingsItem, index) in trainerItem.settings" 
              :key="settingsItem.id"
              class="trainer-params-item"
            >
              <span class="trainer-params-text"> Авто ({{ settingsItem.quality_from + '-' + settingsItem.quality_to }})</span>
              <span v-if="!is_template" @click="removeSettings(trainerItem.settings, index)" class="trainer-params-remove">🞩</span>
              <TrainerInfo 
                :trainer="trainerItem.trainer"
                :params="trainerItem.params" 
                :autoSettings="settingsItem.settings"
              />              
            </div>
          </div>
          
          <div class="homework__params homework__params--students">
            <small>Ученики:</small>
            <span>{{ getStudents(trainerItem.students) }}</span>
          </div>
        </div>
      </li>
    </draggable>

    <div v-else class="empty-message">
      Добавьте тренажёры и нажмите "Сохранить"
    </div>

    <div class="homework__buttons" v-show="!is_saved">
      <div class="save-menu">
        <button 
          class="save-menu__item save-menu__item--save"
          href="#" 
          @click.prevent="saveHomework" 
          :disabled="!isValid"
        >
         <i class="far fa-save"></i> Сохранить
        </button>

        <button 
          class="save-menu__item"
          href="#" 
          @click.prevent="saveTemplate" 
          v-if="formData.is_new && isValid"
        >
          <i class="far fa-plus-square"></i> Создать шаблон
        </button>

        <button 
          class="save-menu__item"
          href="#" 
          @click.prevent="updateTemplate" 
          v-if="formData.is_new && formData.title"
        >
         <i class="far fa-edit"></i> Изменить шаблон
        </button>        
      </div>

    </div>   

    <span v-show="!is_saved && isValid" class="warning-message">Внимание! Данные не сохранены.</span> 
    <span v-show="!is_saved && !isValid" class="warning-message">{{ validMessage }}</span>  

    <Popup :isOpened="popupIsOpened" @close="popupIsOpened = false">
      <template v-slot:content>
        <component 
          :is="popupContent" 
          :data="popupData" 
          @close-popup="popupIsOpened = false" 
          @add-trainer="addTrainer"
          @data-changed="is_saved = false"
          @add-auto-settings="addAutoSettings"
          :class_students="class_students"
          :is_dynamic="formData.is_dynamical"
        ></component>
      </template>
    </Popup>
  </li>
</template>

<script>
import { popup_mix } from '../../../../mixins/popup_mix'
import { addItem, deleteItem } from '../../../../other/methods/list_actions'

import AddTrainer from '../AddTrainer.vue'
import TrainerInfo from '../../../trainer/TrainerInfo.vue'
import AddAutoSettings from './AddAutoSettings'
import { mapGetters, mapMutations } from 'vuex'
import swal from 'sweetalert'
import draggable from 'vuedraggable'
import moment from 'moment'
export default {
  props: ['item', 'class_students', 'is_template', 'index', 'classLessons'],
  mixins: [ popup_mix ],
  inject: ['http'],
  components: { AddTrainer, TrainerInfo, AddAutoSettings, draggable },
  data() {
    return {
      is_saved: true,
      editDate: false,
      formData: {},
      validMessage: ''
    }
  },
  computed: {
    ...mapGetters({
      user: 'user',
      templates: 'teacher/templates'
    }),
    isEndingsHomework() {
      let lastDate = moment(this.item.dates[this.item.dates.length - 1], 'DD.MM.YYYY')
      let currentDate = moment().add(1, 'days')

      return currentDate.isSameOrAfter(lastDate) ? true : false
    },
    disabledDate() {
      let current = new Date()
      current.setDate(current.getDate() - 2)

      return current
    },
    isValid() {
      let valid = true
      let message = ''

      if (!this.formData.trainers.length) {
        valid = false
        message += 'Добавьте тренажёры. '
      }

      if (this.formData.is_dynamical) {
        this.formData.trainers.forEach(item => {
          if (!item.date || !item.students.length) {
            valid = false

            if (!message.includes('Проверьте дату и учеников. ')) {              
              message += 'Проверьте дату и учеников. '
            }            
          }

          let rangeNumbers = 0

          item.settings.forEach(s => {
            let arr = Array.from(Array(s.quality_to - s.quality_from).keys());
            rangeNumbers +=arr.length
          })

          if (rangeNumbers < 100) {
            valid = false
            if (!message.includes('Заполните весь диапазон авто-настроек. ')) {
              message += 'Заполните весь диапазон авто-настроек. '
            }            
          }
        })
      } else {
        this.formData.trainers.forEach(item => {
          if (!item.students.length) {
            valid = false

            if (!message.includes('Добавьте учеников. ')) {            
              message += 'Добавьте учеников. '
            }
          }
        })
      }

      this.validMessage = message

      return valid
    }
  },
  methods: {
    ...mapMutations({
      addTemplate: 'teacher/addTemplate',
      deleteTemplate: 'teacher/deleteTemplate'
    }),
    addItem,
    deleteItem,
    addTrainer(trainer) {
      this.formData.trainers.push(trainer)
      this.is_saved = false
    },
    copyTrainer(trainer, index) {
      let item = _.cloneDeep(trainer)
      item.template_id = null
      this.formData.trainers.splice(index, 0, item)
      this.is_saved = false
    },
    removeTrainer(index) {
      this.formData.trainers.splice(index, 1)
      this.is_saved = false
    },
    addAutoSettings(data) {
      this.formData.trainers[data.index].settings.push(data.settings)
      this.is_saved = false
    },
    removeSettings(arr, index) {
      arr.splice(index, 1)
      this.is_saved = false
    },
    checkDynamic() {
      this.formData.trainers = []
      if (!this.formData.is_dynamical) {
        this.formData.dates = [new Date().toLocaleDateString('ru-RU')]        
      }
    },
    getStudents(students) {
      let filtered = this.class_students.filter(item => students.includes(item.id)); 
      return filtered.map(item => item.name).join(', ')
    },
    saveTemplate() {
      swal({
        title: 'Новый шаблон',
        text: "Введите название шаблона",
        content: {
          element: "input",
          attributes: {
            placeholder: "Название",
          },
        },
        dangerMode: true,
        icon: "warning",
        buttons: ["Отмена", "Ок"],
      }).then((input) => {
        let names = this.templates.map(item => item.title)
        if (names.includes(input)) {
          swal('Ошибка!', 'Шаблон с таким именем уже существует', 'error')
        } else if (input !== null) {
          let template = _.cloneDeep(this.formData)
          
          template.is_template = true
          template.teacher_id = this.user.id
          template.title = input

          this.http.post('onSaveTemplate', template).then(res => {
            this.addTemplate(res.data)
            console.log(res.data)
            swal('Успешно!', `Шаблон ${input} сохранён`, 'success')
          })
          .catch(e => swal('Что-то пошло не так', '' + e, 'error' ))
        }
      });
    },
    updateTemplate() {
      console.log(this.formData)
      swal({
        title: `Обновить текущий шаблон?`,
        text: `Чтобы изменить название, введите новое`,
        icon: "warning",
        buttons: ['Отмена', 'Да'],
        dangerMode: true,
        content: {
          element: "input",
          attributes: {
            placeholder: "Название",
            value: this.formData.title
          },
        }
      })
      .then((input) => {
        if (input !== null) {
          if (input) {
            this.formData.title = input
          }
          console.log(this.formData)
          this.http.post('onUpdateTemplate', this.formData).then(() => {
            swal('Успешно!', 'Шаблон обновлён', 'success')
            let template = _.cloneDeep(this.formData)
            template.is_template = true
            template.is_new = false

            this.addTemplate(template)
          }) 
          .catch(e => swal('Что-то пошло не так', '' + e, 'error'))
        } 
      })
    },
    removeTemplate() {
      swal({
        title: 'Внимание!',
        text: `Действительно желаете удалить шаблон ${this.formData.title}?`,
        icon: "warning",
        buttons: ['Отмена', 'Да'],
        dangerMode: true,
      })
      .then((choise) => {
        if (choise) {
          this.http.post('onDeleteTemplate', { id: this.formData.id }).then(() => {
            this.deleteTemplate(this.formData)
            swal('Успешно!', 'Шаблон удалено', 'success')
          }) 
          .catch(e => swal('Что-то пошло не так', '' + e, 'error'))
        } 
      })
    },
    saveHomework() {
      let formData = this.formData
      formData.teacher_id = this.user.id

      this.http.post('onSaveHomework', formData).then(res => {
        let homework = res.data
        this.deleteItem(formData.id, this.classLessons)
        this.addItem(this.classLessons, homework)

        this.is_saved = true
        swal('Успешно!', 'Домашнее задание сохранено', 'success')
      })
      .catch(e => swal('Что-то пошло не так', '' + e, 'error'))
    }   
  },
  created() {
    this.formData = this.item
    this.is_saved = !this.item || this.item.is_new ? false : true
  },
  watch: {
    item() {
      this.formData = this.item
    }
  }
}
</script>

<style lang="scss" scoped>
.homework__date {
  cursor: pointer;
}
.homework__buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
  & a {
    margin-top: 10px;
    text-decoration: underline;
  }
}

.hide {
  display: none;
}

.homework__params--students {
  margin-top: 5px;
}

.hwtrainer__item {
  border: 1px solid #e2e2e2;
  border-left-width: 10px;
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 10px;
}

.trainer-list {
  margin-top: 20px;
  padding: 0;
  list-style: none;
}

.save-button {
  align-self: center;
  padding: 10px 40px;
  margin-top: 20px;
}

.empty-message {
  padding: 30px;
  text-align: center;
  color: #999999;
}

.warning-message {
  text-align: center;
  margin-top: 5px;
  font-size: 14px;
  color: rgb(255, 151, 144);
}

.homework__item {
  display: flex;
  flex-direction: column;
  position: relative;
}

.setup__item {
  margin: 0;
  margin-left: 5px;
}

.header-menu {
  margin: 0;
  justify-content: flex-start;
}

.trainer-params-info {
  display: flex;
}
.trainer-params-item {
  margin-right: 10px;
}


.trainer-params-text {
  font-size: 12px;
  color: #999999;
}

.header-menu__btn {
  font-size: 13px;
}

.new {
  border-color: #23ee3e;
  border-width: 2px;
}
.ending {
  box-shadow: 0 0 0 2px #fc5d5d inset;
}

.trainer-params-remove,
.remove-template-btn {
  font-size: 16px;
  color: #fc5d5d;
  font-weight: bold;
  cursor: pointer;
}

.remove-template-btn {
  font-size: 26px;
  font-weight: bold;
}

.template-name {
  font-size: 14px;
  text-transform: uppercase;
  color: #999999;
}

.template-menu {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.save-menu {
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
  margin-bottom: 20px;
  animation: fade 0.6s;
  width: 100%;

  & p {
    margin: 0;
  }

  & .save-menu__item {
    margin: 0;
    margin-top: 10px;
    text-decoration: none;
    outline: none;
    background-color: transparent;
    padding: 8px;
    border: 2px solid #0f6ecd;
    color: #0f6ecd;
    border-radius: 8px;
    margin-right: 10px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;

    &:hover {
      background-color: #d5e3f1;
    }

    &--save {
      color: #68da3e;
      border-color: #68da3e;
 
      &:hover {
        background-color: #d0f7c2;
      }
    }

    &:disabled {
      opacity: 0.6;
      color: #666666;
      border-color: #666666;
    }
  }
}

.close--remove-template::after,
.close--remove-template::before {
  background-color: red;
}
</style>